import indexer, { RequireOnlyOne, RequireAtLeastOne } from "../types/genericTypes";
import LoginService, { getAccData } from "./login/loginService";

declare let clevertap: ClevertapType;

export interface ClevertapType {
	event: Array<ClevertapEvent | string>;
	profile: Array<object>;
	account: Array<ClevertapAccount>;
	onUserLogin: Array<ClevertapUserProfile>;
	notifications: Array<CleverTapNotification>;
	privacy: Array<RequireOnlyOne<ClevertapProfile, "optout" | "useIP">>;
	getCleverTapID: () => string;
}

export interface ClevertapEvent {
	[x: string]: any;
	EventName: string;
}

export interface ClevertapAccount {
	id: string;
}

export interface ClevertapUserProfile {
	Site: {
		Name?: string;
		Identity?: string | number;
		Email?: string;
		Phone?: string;
		Gender?: "M" | "F";
		DOB?: Date;
		AccountType?: string;
		profileID?: string;
		"MSG-email"?: boolean;
		"MSG-push"?: boolean;
		"MSG-sms"?: boolean;
		"MSG-whatsapp"?: boolean;
	};
}

export interface CleverTapNotification {
	titleText: string;
	bodyText: string;
	okButtonText: string;
	rejectButtonText: string;
	okButtonColor: string;
	askAgainTimeInSeconds: number;
	serviceWorkerPath: string;
}

export interface ClevertapProfile {
	optout: boolean;
	useIP: boolean;
}

export class ClevertapService {
	pushEvent(data: ClevertapEvent) {
		clevertap.event.push(data.EventName, data);
	}

	// Input: Identity or Email is required. All others are optional
	pushOnUserLogin(data: { Site: RequireAtLeastOne<ClevertapUserProfile["Site"], "Identity" | "Email"> }) {
		clevertap.onUserLogin.push(data);
	}

	pushNotifications(data: CleverTapNotification) {
		clevertap.notifications.push(data);
	}

	getCleverTapID() {
		return clevertap.getCleverTapID();
	}

	getIdentity = () => {
		const cleverTapObject = { accName: "", uniqueId: "", accTyp: "" };
		const decode = LoginService.getAccData();

		let accCode = "";
		if (decode.accTyp === "COMEQ") {
			accCode = decode.prefAccTyp === "EQ" ? decode.eqAccID : decode.coAccID;
			cleverTapObject.accName = decode.prefAccTyp === "EQ" ? decode.eqAccName : decode.coAccName;
			cleverTapObject.accTyp = decode.prefAccTyp;
		} else {
			accCode = decode.accTyp === "EQ" ? decode.eqAccID : decode.coAccID;
			cleverTapObject.accName = decode.accTyp === "EQ" ? decode.eqAccName : decode.coAccName;
			cleverTapObject.accTyp = decode.accTyp;
		}
		cleverTapObject.uniqueId = accCode + "-" + cleverTapObject.accTyp;
		return cleverTapObject;
	};

	getClevertapItem = (key: string) => {
		const value = localStorage.getItem("clevertap") ? JSON.parse(localStorage.getItem("clevertap")!)[key] : undefined;

		// check if value is present and it is not expired
		if (value && new Date(value.split(";")[1]) > new Date()) {
			return value.split(";")[0];
		}
		return undefined;
	};

	setClevertapItem = (obj: indexer) => {
		let clevertapData = localStorage.getItem("clevertap");
		clevertapData = clevertapData ? { ...JSON.parse(clevertapData), ...obj } : obj;
		localStorage.setItem("clevertap", JSON.stringify(clevertapData));
	};

	// key - can be string if only one element needs to be deleted otherwise it is array
	removeClevertapItem = (key: string | Array<string>) => {
		const clevertapData = localStorage.getItem("clevertap") ? JSON.parse(localStorage.getItem("clevertap")!) : {};
		if (typeof key === "string") {
			delete clevertapData[key];
		} else {
			key.forEach((k) => {
				delete clevertapData[k];
			});
		}
		localStorage.setItem("clevertap", JSON.stringify(clevertapData));
	};

	saveClevertapData =  () => {
		const cleverTapObject = this.getIdentity();
		const cleverTapId = clevertap.getCleverTapID();
		const login = getAccData();
		this.setClevertapItem({
				cleverTapDetails: login.prfId + "," + cleverTapId + ";expires=Tue, 19 Jan 2025 12:00:00 GMT",
				lastLoginDetails: login.prfId + "," + cleverTapId + "," + cleverTapObject.accName + "," + cleverTapObject.uniqueId + "," + cleverTapObject.accTyp + "," + login.accTyp + ";expires=Tue, 19 Jan 2025 12:00:00 GMT"
		});
}

	showClevertapNotification = () => {
		setTimeout(() => {
			clevertap.notifications.push({
				titleText: "Would you like to receive Push Notifications?",
				bodyText: "We promise to only send you relevant content and give you updates on your transactions",
				okButtonText: "Sign me up!",
				rejectButtonText: "No thanks",
				okButtonColor: "#f28046",
				askAgainTimeInSeconds: 604800,
				serviceWorkerPath: process.env.PUBLIC_URL + "/serviceworker.js"
			});
		}, 10000);
	};
}
